import { ChannelTypeEnum } from "../../types";
import EventBus from "../event-bus";
const loginSuccessHook = new EventBus<{
  channelType: ChannelTypeEnum;
  user_id: string;
}>("loginSuccessHook");

export default loginSuccessHook;
